import LayoutContentArea from "@/components/layout/LayoutContentArea";
import { ChildDataView } from "@/components/records/child-data-view/ChildDataView";

export default function ChildDataViewPage() {
  return (
    <LayoutContentArea headingText="Child Data View">
      <ChildDataView />
    </LayoutContentArea>
  );
}
